export const grid = {
  columns: 12,
  gutter: 20,
  margin: 0,
  maxWidth: {
    md: "100%",
    lg: "1440px",
    xl: "1440px",
    sm: "100%",
  },
};
